import React from "react";
import styles from "./homepagerecomment.module.css";
import ProductCard from "../ProductCard";
import { useTranslation } from "react-i18next";
const RecommentProduct = ({ recomment_products }) => {
  const { t } = useTranslation();
  // Ensure we only take the top 12 products
  const recomment_Products = recomment_products.slice(0, 12);

  return (
    <div className="container-fluid mt-3vw">
      <h2 className={styles.mt}>{t("today_suggestion")}</h2>
      <div className="row">
        {recomment_Products.map((product, idx) => (
          <div className="col-md-3" key={idx}>
            <ProductCard
              productId={product.productId}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommentProduct;
